
import { Component, OnInit, Input } from '@angular/core';
import { BcAccountClientService } from '../../../../../billing-control/bc-account-client/service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
	selector: 'app-et-proposal-view',
	templateUrl: './et-proposal-view.component.html',
	providers: [
		BcAccountClientService
	]
})

export class EtProposalViewComponent implements OnInit {

	@Input('proposal') proposal = [];

	public reasonOfExtensions:any[] = [];
	public moneySources:any[] = [];
	public parcelas: any[] = [];
	public guaranteeTypes: any[] = [];
	public extensionDetails: any[] = [];

	constructor(private bcAccountClientService: BcAccountClientService, private flashMessagesService: FlashMessagesService) {
	}

	ngOnInit() {
		this.searchReasonOfExtension();
		this.searchMoneySource();
		this.searchGuaranteeType();
		this.getExtensionDetails();

		console.log("Proposta de Prorrogação", this.proposal);

		if (this.proposal['Parcelamentos']) {
			for (var i = 0; i < this.proposal['Parcelamentos'].length; i++) {
				this.parcelas[i].Parcela = this.proposal['Parcelamentos'][i].Parcela;
				this.parcelas[i].Valor = this.proposal['Parcelamentos'][i].Valor;
				this.parcelas[i].Ativo = this.proposal['Parcelamentos'][i].Ativo;
			}
		}
	}

	getExtensionDetails() {
		this.bcAccountClientService.getExtensionDetails(this.proposal['ID']).subscribe(result => {
			if (result.Success) {
				this.extensionDetails = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	searchReasonOfExtension() {
		this.bcAccountClientService.searchReasonOfExtension().subscribe(result => {
			if (result.Success) {
				this.reasonOfExtensions = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	searchMoneySource() {
		this.bcAccountClientService.searchMoneySource().subscribe(result => {
			if (result.Success) {
				this.moneySources = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	searchGuaranteeType() {
		this.bcAccountClientService.searchGuaranteeType().subscribe(result => {
			if (result.Success) {
				this.guaranteeTypes = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	printDiv(divName) {
		var printContents = document.getElementById(divName).innerHTML;
		var originalContents = document.body.innerHTML;
		document.body.innerHTML = printContents;
		window.print();
		document.body.innerHTML = originalContents;
   }

}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/proposal-view-modal/ETproposal-view/et-proposal-view.component.ts